import { motion } from "framer-motion";
import { CHAPTERS, IMG } from "@/data/menu";
import { Reveal } from "@/components/site/Reveal";

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="bg-beige noise relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-5 order-2 lg:order-1">
            <div className="rounded-[2.5rem] overflow-hidden border border-line">
              <img src={IMG.community} alt="Fitness community" className="w-full h-[520px] object-cover" />
            </div>
          </Reveal>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-teal-brand">Our Manifesto</p>
              <h2 className="mt-3 font-display text-4xl sm:text-6xl font-bold tracking-tight text-coffee leading-[0.95]">
                Making fitness nutrition transparent, accessible &amp; delicious.
              </h2>
              <p className="mt-6 text-lg text-coffee-soft leading-relaxed max-w-2xl" data-testid="founder-story">
                ProteinCafe started in a Bengaluru garage gym, where our founders — lifelong athletes tired of guessing
                what was really in their shakes — set out to build a place that puts every macro right on the label.
                What began as one blender and a promise of total transparency grew into The Fuel Lounge™: a community
                where honest nutrition and genuinely great taste finally live under one roof.
              </p>
            </Reveal>

            <div className="mt-12 space-y-10">
              {CHAPTERS.map((c, i) => (
                <motion.div
                  key={c.no}
                  data-testid={`chapter-${i}`}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.05 }}
                  className="relative pl-20"
                >
                  <span className="absolute left-0 top-0 font-display text-6xl font-black text-teal-brand/20 leading-none">{c.no}</span>
                  <h3 className="font-display text-2xl font-bold text-coffee">{c.title}</h3>
                  <p className="mt-2 text-coffee-soft leading-relaxed max-w-xl">{c.body}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
